import React from "react";
import Wrap from "../wrap";
import "./styles.css";

const Main = ({ children, isBlog }) => (
  <main className={`Main ${isBlog ? "blog" : ""}`}>
    <Wrap>{children}</Wrap>
  </main>
);

export default Main;



/** WEBPACK FOOTER **
 ** ./src/views/components/main/index.js
 **/